











































import { Component, Prop, Watch } from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { Location } from "vue-router";
import Heading from "../shared/Header.vue";
import Button from "@/shared/components/ui/Button.vue";
import Enrollment from "@/employer/components/dashboard/Enrollment.vue";
import EnrollmentWidget from "@/employer/components/widgets/EnrollmentWidget.vue";
import ContributionsWidget from "@/employer/components/widgets/ContributionsWidget.vue";
import FicaSavingsWidget from "@/employer/components/widgets/FicaSavingsWidget.vue";
import EmployeeNavigatorWidget from "@/employer/components/widgets/EmployeeNavigatorWidget.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AddEmployeeLinkWidget from "@/employer/components/widgets/AddEmployeeLinkWidget.vue";
import { FundingOption, Permission, UserEventKey, UserEventType } from "@/shared/types";
import { CensusManager } from "@/employer/types";
import { openUrl } from "@/shared/urlHelper";
import { useEmployeeInviteDateStore } from "@/employer/store/employeeInviteDate";
import { useUserStore } from "@/shared/store/user";
import { useDashboardStore } from "@/employer/store/dashboard";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useCommunicationStore } from "@/shared/store/communication";
import DashboardMetrics from "@/employer/components/dashboard/DashboardMetrics.vue";
import { useFocusReload } from "@/employer/composables/useFocusReload";

@Component({
  components: {
    Button,
    Heading,
    Enrollment,
    EnrollmentWidget,
    ContributionsWidget,
    FicaSavingsWidget,
    EmployeeNavigatorWidget,
    GenericLoadingSpinner,
    AddEmployeeLinkWidget,
    DashboardMetrics
  }
})
export default class EmployerHome extends mixins(ErrorsMixin) {

  employeeInviteDateStore = useEmployeeInviteDateStore();
  userStore = useUserStore();
  dashboardStore = useDashboardStore();
  custodianSettingsStore = useCustodianSettingsStore();
  rolePermissionsStore = useRolePermissionsStore();
  communicationStore = useCommunicationStore();

  @Prop() employerId: number;
  @Prop()
  routeToNewEmployee: () => Location;

  get displayContributionsWidgetGraph (): boolean {
    const hasPermission = this.rolePermissionsStore.userHasPermission(Permission.PayrollRead);

    if (!hasPermission) {
      return false;
    }

    return this.userStore.currentEmployer && this.userStore.currentEmployer.fundingOption === FundingOption.BendCalculatePull;
  }

  created () {
    if (this.isApexUser) {
      useFocusReload();
    }
    this.reset();
    this.loadCommunications();
  }

  reset () {
    this.userStore.changeActiveEmployer({ employerId: this.employerId });
    if (this.userStore.loggedIn) {
      if (this.rolePermissionsStore.userHasPermission(Permission.CensusWrite)) {
        this.employeeInviteDateStore.getEarliestInviteDate(this.employerId).catch(this.handleError);
      }
      this.dashboardStore.initDashboard();
      this.custodianSettingsStore.getEmployerCustodian();
    }
  }

  get isApexUser (): boolean {
    return this.userStore.isApexUser();
  }

  get hasEmployeeWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.EmployeeWrite);
  }

  get displayEarliestInviteSentMessage (): boolean {
    return this.employeeInviteDateStore.isEmailSendPending && this.custodianSettingsStore.displayEmployerEmployeeInviteLink;
  }

  get showSpinner () { return this.userStore.loggedIn && !this.dashboardStore.showDashboard; }

  get displayEmployeeNavigatorContent (): boolean {
    return this.userStore.currentEmployer && this.userStore.currentEmployer.censusManager === CensusManager.employeeNavigator;
  }

  gotoNewEmployee (e): void {
    e.preventDefault();
    this.$router.push(this.routeToNewEmployee());
  }

  @Watch("employerId")
  onEmployerIdChanged () {
    this.reset();
    this.loadCommunications();
  }

  loadCommunications () {
    if (this.employerId) {
      this.communicationStore.loadEmployerCommunications(this.employerId);
    }
  }

  handleActionLinkClick (v: any) {
    const r = this.communicationStore.communications.filter(x => x.id === v)[0];
    openUrl(r.actionLink);
    this.userStore.saveUserEvent({
      eventType: UserEventType.PartnerCommunicationWidgetClick,
      values: [
        { key: UserEventKey.PartnerCommunicationId, value: r.id },
        { key: UserEventKey.PartnerCommunicationSubject, value: r.subject },
        { key: UserEventKey.PartnerCommunicationLocation, value: "employer" }
      ]
    });
  }
}
